'use client';

import { useEffect } from 'react';

import { initMetaPixel } from '~/lib/analytics/meta-pixel';

import { useCookieConsent } from '../cookie-consent-context';

/**
 * Fires the dedicated Selenos Meta Pixel on the Selenos brand surfaces
 * (selenos.ai homepage, /pilot, /contact). Reads NEXT_PUBLIC_SELENOS_PIXEL_ID
 * at build time; no-ops if unset.
 *
 * Consent-gated: the pixel (a marketing tracker, ~240KB of third-party JS)
 * loads only after the visitor grants the marketing category — the banner
 * promises exactly that. Exempt jurisdictions grant it via the consent
 * context. initMetaPixel is idempotent, so late grants init exactly once.
 *
 * Mounted ONLY on Selenos root pages, never the shared (marketing) layout, so
 * the per-vertical [vertical]/[city] landing pages keep firing only their own
 * pixel (no double-fire). This is the Selenos counterpart to MetaPixelInit.
 */
export function SelenosPixel() {
  const { marketing } = useCookieConsent();

  useEffect(() => {
    const pixelId = process.env.NEXT_PUBLIC_SELENOS_PIXEL_ID;

    if (marketing && pixelId) {
      initMetaPixel(pixelId);
    }
  }, [marketing]);

  return null;
}
